import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {TokenStorageService} from '@tbg/ui-components/support';
import {catchError, Observable, switchMap, take, throwError} from 'rxjs';
import {environment} from '../../environments/environment';
import {SebgDebriefing} from './sebg-debriefing.models';

@Injectable({providedIn: 'root'})
export class TeacherSessionApiService {
  constructor(private http: HttpClient, private tokens: TokenStorageService) {}

  summary<T>(): Observable<T> { return this.read<T>('session-summary'); }
  debriefing(): Observable<SebgDebriefing> { return this.read<SebgDebriefing>('session-debriefing'); }

  private read<T>(endpoint: string): Observable<T> {
    const url = `${environment.apiUrl}/teacher/${endpoint}`;
    return this.tokens.data$.pipe(take(1), switchMap(token => {
      const jwt = token.jwt;
      if (!jwt) {
        console.warn('Teacher session: no stored authorization token', {url});
        return throwError(() => new HttpErrorResponse({status: 401, url, statusText: 'Teacher token missing'}));
      }
      // Teacher requests must carry authorization even when the deployed interceptor chain differs.
      return this.http.get<T>(url, {headers: {Authorization: jwt}}).pipe(catchError((error: HttpErrorResponse) => {
        console.warn('Teacher session request failed', {url, status: error.status, tokenPresent: true});
        return throwError(() => error);
      }));
    }));
  }
}
